import { ThemeKeys, themes } from '@tradener/lumen';

const DEFAULT_THEME: ThemeKeys = 'TRADENER';

const isThemeKey = (value?: string): value is ThemeKeys => !!value && value in themes;

export const lumenTheme: ThemeKeys = isThemeKey(process.env.REACT_APP_LUMEN_THEME)
  ? process.env.REACT_APP_LUMEN_THEME
  : DEFAULT_THEME;
